module.exports = __webpack_public_path__ + "static/media/complete.96f3b56d.svg";